import {
  ResolvedReflectiveProvider,
  Directive,
  ViewContainerRef,
  Attribute,
  ComponentRef,
  ComponentFactory,
  ReflectiveInjector
} from '@angular/core';
import {RouterOutletMap} from '../router';
import {DEFAULT_OUTLET_NAME} from '../constants';
import {isPresent, isBlank} from '../facade/lang';
export class RouterOutlet {
  private _activated: ComponentRef<any>;
  public outletMap: RouterOutletMap;

  constructor(parentOutletMap: RouterOutletMap, private _location: ViewContainerRef, name: string) {
    parentOutletMap.registerOutlet(isBlank(name) ? DEFAULT_OUTLET_NAME : name, this);
  }

  deactivate(): void {
    this._activated.destroy();
    this._activated = null;
  }

  /**
   * Returns the loaded component.
   */
  get component(): Object { return isPresent(this._activated) ? this._activated.instance : null; }

  /**
   * Returns true is the outlet is not empty.
   */
  get isActivated(): boolean { return isPresent(this._activated); }

  /**
   * Called by the Router to instantiate a new component.
   */
  activate(factory: ComponentFactory<any>, providers: ResolvedReflectiveProvider[],
           outletMap: RouterOutletMap): ComponentRef<any> {
    this.outletMap = outletMap;
    let inj = ReflectiveInjector.fromResolvedProviders(providers, this._location.parentInjector);
    this._activated = this._location.createComponent(factory, this._location.length, inj, []);
    return this._activated;
  }
static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{selector: 'router-outlet'}, ] },
];
static ctorParameters: {type: Function, decorators?: DecoratorInvocation[]}[] = [
{type: RouterOutletMap, },
{type: ViewContainerRef, },
{type: undefined, decorators: [{ type: Attribute, args: ['name', ] }, ]},
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
